/* eslint-disable */
import React, { Component } from "react";
import { List } from "semantic-ui-react";
import {
  Button,
  TransitionablePortal,
  Header,
  Icon,
  Modal,
  Image,
  Popup,
  Segment,
  Divider,
} from "semantic-ui-react";

class RoomInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      imagePath: undefined,
    };
  }
  render() {
    const checkIfGroupHasImages = (group) => {
      var hasImages = false;
      if (group.items) {
        for (let i = 0; i < group.items.length; i++) {
          group.items[i].images.length > 0 && group.items[i].images.some( i => i.image_path != null) ? (hasImages = true) : null;
        }
      }
      return hasImages;
    };
    return (
      <React.Fragment>
        <div className="nested-segment">
                <Header className="nested-segment" as="h2" attached="top"><Icon color="blue" name="list" />
                   <Header.Content>{this.props.room.name}</Header.Content> 
          </Header>
          <Segment attached className="nested-segment">
            {this.props.room.images.length > 0 ? (
              <React.Fragment>
                <div className="nested-segment">
                  <Segment attached="top" secondary>
                    <Header as="h3"><Icon color="grey" name="photo" />General View</Header>
                  </Segment>
                  <Segment attached>
                    <Image.Group size="small">
                      {this.props.room.images.map((image) => {
                        return (
                          image.image_path?<Popup
                            key={image.id}
                            trigger={
                              <Image
                                style={{ cursor: "pointer" }}
                                className="grow"
                                rounded
                                src={image.image_path}
                                onClick={() => {
                                  this.props.setCurrentImage(image)
                                }}
                              />
                            }
                          >
                            General View
                          </Popup>:null
                        );
                      })}
                    </Image.Group>
                  </Segment>
                </div>
              </React.Fragment>
            ) : null}
            {this.props.room.groups.map((group) => {
              const hasImages = checkIfGroupHasImages(group);
              return hasImages ? (
                <React.Fragment key={group.client_id}>
                  <Divider section />
                  <div className="nested-segment">
                    <Segment secondary attached="top">
                      <Header as="h3"><Icon color="grey" name="photo" /> {group.name}</Header>
                    </Segment>
                    <Segment attached>
                      <Image.Group size="small">
                        {group.items.map((item) => {
                          return item.images
                            ? item.images.map((image) => {
                                return (
                                  image.image_path?<Popup
                                    key={image.id}
                                    trigger={
                                      <Image
                                        style={{ cursor: "pointer" }}
                                        className="grow"
                                        onClick={() => {
                                          this.props.setCurrentImage(image)
                                        }}
                                        rounded
                                        src={image.image_path}
                                        target="_blank"
                                      />
                                    }
                                  >
                                    <List divided>
                                      <List.Item>
                                        <List.Content>
                                          <List.Header
                                            style={{ color: "#4183c4" }}
                                          >
                                            Item Description
                                          </List.Header>
                                          <List.Description>
                                            {item.name}
                                          </List.Description>
                                        </List.Content>
                                      </List.Item>
                                      {
                                        <List.Item>
                                          <List.Content>
                                            <List.Header style={{ color: "#4183c4" }}>
                                              Check In Note
                                            </List.Header>
                                            <List.Description>
                                              {item.ci_notes ? item.ci_notes : (this.props.reportType === "other" ? "See Original Report" :"No dilapidations observed")}
                                            </List.Description>
                                          </List.Content>
                                        </List.Item>
                                      }
                                      {
                                        <List.Item>
                                          <List.Content>
                                            <List.Header
                                              style={{ color: "#4183c4" }}
                                            >Check Out Note
                                            </List.Header>
                                            <List.Description>
                                              {item.co_notes ? item.co_notes : "Same condition as check in"}
                                            </List.Description>
                                          </List.Content>
                                        </List.Item>
                                      }
                                    </List>
                                  </Popup>:null
                                );
                              })
                            : null;
                        })}
                      </Image.Group>
                    </Segment>
                  </div>
                </React.Fragment>
              ) : null;
            })}
          </Segment>
        </div>
        <Divider section />
      </React.Fragment>
    );
  }
}

export default RoomInfoContainer;



// WEBPACK FOOTER //
// ./src/views/report/report_viewer/room_info_container.js